import React from 'react';
import { Link } from 'react-router-dom';

export default function SeoBreadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-muted mb-6">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={`${item.path}-${index}`} className="flex items-center gap-2">
            {index > 0 && <span aria-hidden="true">/</span>}
            {index === items.length - 1 ? <span className="text-ink">{item.name}</span> : <Link className="text-navy hover:underline" to={item.path}>{item.name}</Link>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
